/*
 * @Description:
 * @Author:  Teemo Ding
 * @Date: 2021-04-14 15:10:57
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-03-27 08:52:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/slice/index.ts
 */

import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
  hasError,
} from 'src/pages/SalesChannelProductsConfig/slice/reduxCommonFunctions';
import {
  EnumCollapseId,
  generateDefaultCarousel,
  generateDefaultContentDetails,
  generateDefaultSEOSetting,
  generateDefaultThumbnailImage,
} from '../common';

import {
  moduleContentDynamicOnChange as _moduleContentDynamicOnChange,
  moduleContentOnChange as _moduleContentOnChange,
  moduleContentStaticOnChange as _moduleContentStaticOnChange,
  onModuleTypeChange as _onModuleTypeChange,
} from 'src/constrains/DraggableModules/reduxFunctions';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getHasModified as _getHasModified,
  getPageEnabled as _getPageEnabled,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getTarget,
  reducers,
} from 'src/pages/SalesChannelProductsConfig/slice/selectors';

import { convertDataFromServerToRedux } from '../tools';

import {
  request_AliasDetail,
  request_ProductContent,
  request_SaveAliasProductContent,
  request_SaveProductContent,
} from '@/src/request/salesChannel/product/content';

import { getI18nFromGeneral } from '@/src/tools/tools';
import arrayMove from 'array-move';

export { EnumCollapseId };

const fixedCollapse = [
  EnumCollapseId.seoSetting,
  EnumCollapseId.contentDetails,
  EnumCollapseId.carousel,
  EnumCollapseId.thumbnailImage,
  EnumCollapseId.miniProgramPageInfo,
  EnumCollapseId.miniProgramShare,
];
const _defaultState = _generateDefaultState(fixedCollapse);
const seoSetting = generateDefaultSEOSetting();
const contentDetails = generateDefaultContentDetails();
const carousel = generateDefaultCarousel();
const thumbnailImage = generateDefaultThumbnailImage();
const defaultState = {
  uuid: '',
  loaded: false,
  enabled: false,
  seoSetting,
  contentDetails,
  carousel,
  alias: [],
  type: '',
  miniProgramShare: {},
  thumbnailImage,
  averageRating: 0,
  reviewCount: 0,
  show: null,
  original: {},
  ..._defaultState,
  ...defaultStatus,
};
const _currentReducer = reducers(EnumReducers.productAliasEdit);

export const submitAlias = createAsyncThunk(
  'submitSalesChannelAlias',
  async ({ body, params }: any) => {
    // const response = {};
    // const isPrimary = isCurrentPrimary();
    const response = await request_SaveProductContent(body, params);
    return response;
  },
);

export const initAliasDetail = createAsyncThunk(
  'initAliasDetail',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await request_AliasDetail(body, params);
    return { response, isPrimary };
  },
);

export const initNewAlias = createAsyncThunk(
  'initNewAlias',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await request_ProductContent(body, params);
    return { response, isPrimary };
  },
);

export const onAddAlias = createAsyncThunk(
  'onAddAlias',
  async ({ body, params }: any) => {
    console.log('onAddAlias');
    body.uuid = '';
    const response = await request_SaveAliasProductContent(body, params);
    return response;
  },
);

const SalesChannelProductAliasEdit = createSlice({
  name: 'SalesChannelProductAliasEdit',
  initialState: defaultState,
  reducers: {
    onEnabledChange(state, action) {
      state.hasModified = true;
      state.enabled = action.payload;
    },

    moduleContentOnChange(state, action) {
      _moduleContentOnChange(state, action);
    },
    onModuleTypeChange(state, action) {
      _onModuleTypeChange(state, action.payload);
    },
    moduleContentStaticOnChange(state, action) {
      _moduleContentStaticOnChange(state, action);
    },
    moduleContentDynamicOnChange(state, action) {
      _moduleContentDynamicOnChange(state, action);
    },

    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },

    onSEOSettingOnChange(state, action) {
      state.hasModified = true;
      const { data } = action.payload;

      if (data.customized) {
        data.title = state.contentDetails.productName;
        data.description = state.contentDetails.productDescription;
      }
      state.seoSetting = { ...state.seoSetting, ...data };
    },

    onMiniProgramShareChange(state, action) {
      state.hasModified = true;
      state.miniProgramShare = {
        ...state.miniProgramShare,
        ...action.payload,
      };
    },

    onContentDetailsOnChange(state, action) {
      state.hasModified = true;
      const { data } = action.payload;
      state.contentDetails = { ...state.contentDetails, ...data };
    },

    onThumbnailImageOnSort(state, action) {
      const { from, to } = action.payload;
      state.hasModified = true;
      state.thumbnailImage = arrayMove(state.thumbnailImage, from, to);
    },
    onThumbnailImageOnChange(state, action) {
      state.hasModified = true;
      const { index, data } = action.payload;
      state.thumbnailImage.linkModules[index] = {
        ...state.thumbnailImage.linkModules[index],
        ...data,
      };
    },
    onThumbnailImageSameAsOriginalOnChange(state, action) {
      state.hasModified = true;
      const { original } = state;
      const { sameAsOriginal = false } = action.payload || {};
      state.thumbnailImage = original.thumbnailImage || {};
      (state.thumbnailImage || {}).sameAsOriginal = sameAsOriginal;
    },
    onDynamicDataAdd(state, action) {
      state.hasModified = true;
      const { draggableId, data } = action.payload;
      state[draggableId].dynamicData.push(data);
    },
    onDynamicDataDelete(state, action) {
      state.hasModified = true;
      const { draggableId, index } = action.payload;
      state[draggableId].dynamicData.splice(index, 1);
    },
    onChangeSameAsOriginal(state, action) {
      state.hasModified = true;
      const { original } = state;
      const { draggableId, sameAsOriginal } = action.payload;
      state[draggableId] = original.carousel;
      state[draggableId].sameAsOriginal = sameAsOriginal;
    },

    onDynamicDataSort(state, action) {
      const { from, to, draggableId } = action.payload;
      state.hasModified = true;
      state[draggableId].dynamicData = arrayMove(
        state[draggableId].dynamicData,
        from,
        to,
      );
    },

    onDynamicDataChange(state, action) {
      state.hasModified = true;
      const { index, data, draggableId } = action.payload;
      if (data.coverImage) {
        //取消其他选择
        state[draggableId].dynamicData = state[draggableId].dynamicData.map(
          (d) => {
            d.coverImage = false;
            return d;
          },
        );
        state[draggableId].dynamicData[index] = {
          ...state[draggableId].dynamicData[index],
          ...data,
        };
      } else {
        state[draggableId].dynamicData[index] = {
          ...state[draggableId].dynamicData[index],
          ...data,
        };
      }
    },

    onDeleteAlias(state, action) {
      state.hasModified = true;
      state.alias.splice(action.payload, 1);
    },

    onStaticChange(state, action) {
      state.hasModified = true;
      const { draggableId, data } = action.payload;
      state[draggableId].staticData = {
        ...state[draggableId].staticData,
        ...data,
      };
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    validation(state) {
      hasError(state, state.collapseErrorMsgDisplay || {});
    },
    resetData(state) {
      assData(state, defaultState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initNewAlias.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      assData(state, _data);
    });
    builder.addCase(initAliasDetail.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      state.hasModified = false;
      assData(state, _data);
    });
    builder.addCase(submitAlias.fulfilled, (state, action) => {
      message.success(
        getI18nFromGeneral('general.status.changessavesuccessfully'),
      );
      assData(state, { hasModified: false });
    });
    builder.addCase(onAddAlias.fulfilled, (state, action) => {
      const { uuid } = action.payload;
      message.success(
        getI18nFromGeneral('general.status.changessavesuccessfully'),
      );
      assData(state, { hasModified: false, aliasUuid: uuid });
    });
  },
});

export const getPageEnabled = () => {
  return _getPageEnabled(EnumReducers.productAliasEdit);
};

export const getCarousel = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.carousel;
    },
    (carousel) => {
      return carousel;
    },
  );
};
export const getThumbnailImage = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.thumbnailImage;
    },
    (thumbnailImage) => {
      return thumbnailImage;
    },
  );
};

export const getContent = (id) => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData[id];
    },
    (content) => {
      return content;
    },
  );
};

export const getAllAlias = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.alias;
    },
    (alias) => {
      return alias;
    },
  );
};
export const getContentDetails = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.contentDetails;
    },
    (contentDetails) => {
      return contentDetails;
    },
  );
};
export const getAliasUuid = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.aliasUuid;
    },
    (aliasUuid) => {
      return aliasUuid;
    },
  );
};

export const getSeoSetting = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.seoSetting;
    },
    (seoSetting) => {
      return seoSetting;
    },
  );
};

export const getOpeningCollapse = (order) => {
  return createSelector(
    (state: any) => {
      const _r = [];
      for (const item of order) {
        const { draggableId: id } = item;
        const stateData = getTarget(state, _currentReducer);
        if (stateData.collapseOpen[id]) {
          _r.push(id);
        }
      }
      return _r;
    },
    (status) => {
      return status;
    },
  );
};
export const getCollapseStatus = (id) => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.collapseOpen[id];
    },
    (status) => {
      return status;
    },
  );
};

export const getAllState = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer),
    (allState) => {
      return allState;
    },
  );
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.productAliasEdit, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.productAliasEdit, id);
};

export const getGeneralFeaturedProduct = () => {
  return _getGeneralFeaturedProduct(EnumReducers.productAliasEdit);
};

export const getState = () => {
  return _getState(EnumReducers.productAliasEdit);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.productAliasEdit);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.productAliasEdit);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.productAliasEdit);
};

export const getGeneralMiniProgramPageInfo = () => {
  return _getGeneralMiniProgramPageInfo(EnumReducers.productAliasEdit);
};

export const getGeneralMiniProgramShare = () => {
  return _getGeneralMiniProgramShare(EnumReducers.productAliasEdit);
};

export const {
  onEnabledChange,
  onCollapseOpen,
  onSEOSettingOnChange,
  moduleContentStaticOnChange,
  moduleContentDynamicOnChange,
  onContentDetailsOnChange,
  onThumbnailImageOnChange,
  onMiniProgramShareChange,
  onThumbnailImageSameAsOriginalOnChange,
  onDynamicDataAdd,
  onThumbnailImageOnSort,
  onDynamicDataDelete,
  onDynamicDataChange,
  onDynamicDataSort,
  onErrorChange,
  onDeleteAlias,
  onChangeSameAsOriginal,
  validation,
  resetData,
  onStaticChange,
  moduleContentOnChange,
  onModuleTypeChange,
} = SalesChannelProductAliasEdit.actions;

export default SalesChannelProductAliasEdit.reducer;
